export default "__VITE_ASSET__k1vO3x3Q__"